/**
 * Recharts palette for SiliconX. Anchored on the brand indigo and
 * progressing through cool→warm hues for stacked/multi-series legibility
 * without resorting to default Tableau-style chaos.
 */
export const SX_PALETTE = [
  '#7c3aed', // violet-600       (primary series)
  '#6366f1', // indigo-500       (secondary)
  '#0EA5E9', // sky-500          (tertiary / low band)
  '#10B981', // emerald-500      (positive deltas)
  '#F59E0B', // amber-500        (warning / mid)
  '#EF4444', // red-500          (negative deltas / alerts)
] as const;
